// إعدادات Cloudinary
// ========================
// 1. اذهب إلى https://cloudinary.com وسجّل حساب مجاني
// 2. من Dashboard انسخ الـ Cloud Name وضعه هنا
// 3. اذهب إلى Settings > Upload > Upload presets
// 4. اضغط "Add upload preset" واختر Signing Mode = Unsigned
// 5. انسخ اسم الـ preset وضعه هنا
// ========================

const CLOUDINARY_CLOUD_NAME = 'ddnrhw560';
const CLOUDINARY_UPLOAD_PRESET = 'react gallery';

const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`;

export { CLOUDINARY_CLOUD_NAME, CLOUDINARY_UPLOAD_PRESET, CLOUDINARY_UPLOAD_URL };
